/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- COMMUNITY TOP ARTICLES PLACEHOLDER IMAGES: STYLES --------------- ++++++++++ */
export default theme => ({
  placeholderimages: {
    '& .sectioncontent': {
      display: 'flex',
      flexFlow: 'row wrap',
      width: '100%',
      '& .control': {
        minWidth: pxToEm(172),
        marginBottom: pxToEm(8),
        marginRight: pxToEm(8)
      },
      '& .imageuploader': {
        marginLeft: pxToEm(24),
        '& .preview': { height: `${pxToEm(48)} !important`, width: 'auto !important' }
      }
    }
  }
});
